import usercentrics from './usercentrics';
import localProvider from './local-provider';

const consentHandlers = {
  usercentrics,
  localProvider
};

export default function UserConsent(consentHandler?: { [key: string]: any }) {
  if (consentHandler && consentHandler.name && consentHandler.handler) {
    return consentHandlers[consentHandler.name](consentHandler.handler);
  }

  return {
    hasConsent: deny,
    grantConsent: noop,
    revokeConsent: noop,
    openConsents: noop
  };
}

function noop() {}

function deny() {
  return false;
}
